import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { UPDATE_USER_PREFERENCE_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import { GET_USER_PREFERENCE_TAG } from './getUserPreferences';
import type { UpdateUserPreferencesPayload, UpdateUserPreferencesResult } from '../types/updateUserPreferences.types';

export const updateUserPreferences = (builder: BuilderType) =>
  builder.mutation<UpdateUserPreferencesResult, UpdateUserPreferencesPayload>({
    invalidatesTags: [GET_USER_PREFERENCE_TAG],
    query: (body) => ({
      data: body,
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: UPDATE_USER_PREFERENCE_URL,
    }),
    transformResponse: (response: GenericApiResponse<UpdateUserPreferencesResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
